import loadable from "@loadable/component";

const Conciairge = loadable(() => import("./Conciairge.page"));

export default { component: Conciairge };
